import { Injectable, EventEmitter, NgZone } from '@angular/core';
declare var $: any;


@Injectable()
export class SessionService {


  public logouturl: string;
  public bloburl: string;
  public loginid: string;
  public alphabetid: string;
  public colorstatus: string;

  constructor(private ngZone: NgZone) {
    this.bloburl = "";
    this.logouturl = "";
    this.loginid = "";
    this.alphabetid = "";
    this.colorstatus = "";
  }

  levelbook(s): void {
    this.loadScript('../../../../assets/fk-commonjs/levelbooks-js/turn.min.js');
    var thisme: any = this;
    setTimeout(function () {
      thisme.levelbookfunc(s);
    }, 500);
  }


  levelbookfunc(s): void {

    this.loadScript('../../../../assets/fk-commonjs/scripts/lazyload.js');

    $("#mybook").show();
    (function () {
      'use strict';
      var elmnt = document.getElementById("mybook");

      var module = {
        ratio: 1.34,
        init: function (id) {
          var me = this;
          
          if (document.addEventListener) {
            this.el = document.getElementById(id);

            this.resize();
            this.plugins();
            
            window.addEventListener('resize', function (e) {
              var size = me.resize();
              $(me.el).turn('size', size.width, size.height);
            });
          }

        },
        resize: function () {

          
          this.el.style.width = '';
          this.el.style.height = '';

          var width = this.el.clientWidth,
            height = Math.round(width / this.ratio),
            padded = Math.round(elmnt.clientHeight * 0.9);

          
          if (height > padded) {
            height = padded;
            width = Math.round(height * this.ratio);
          }

          
          this.el.style.width = width + 'px';
          this.el.style.height = height + 'px';

          return {
            width: width,
            height: height
          };


        },

        plugins: function () {



          var oTurn = $(this.el).turn({



            when: {
              turning: function (e, page, view) {

                var book = $(this),
                  currentPage = book.turn('page'),

                  pages = book.turn('pages');

                if (page < 2) {

                  $('#book').addClass('fk_align1');

                  $('#fk_leftbar').addClass('hidden');
                }



                else {
                  $('#book').removeClass('fk_align1');
                  $('#fk_leftbar').removeClass('hidden');
                }

                var page_arr = [11, 11, 11, 11, 11, 11, 11, 11, 11, 11,
                  11, 15, 11, 11, 15, 11, 18, 19, 18, 19,
                  19, 19, 19, 19, 19, 19, 19, 19, 19, 19,
                  19, 19, 19, 19, 19, 19, 19, 19, 19, 19,
                  27, 27, 27, 27, 27, 27, 27, 27, 27, 27,
                  27, 27, 27, 27, 27, 27, 35, 27, 27, 35,
                  35, 35, 35, 35
                ];


                if (page > page_arr[s]) {
                  $('#book').addClass('fk_align2');
                  $('#fk_rightbar').addClass('hidden');
                }

                else {
                  $('#book').removeClass('fk_align2');
                  $('#fk_rightbar').removeClass('hidden');
                }

              }
            }



          });


          $("#fk_leftbar").click(function (e) {

            e.preventDefault();
            oTurn.turn("previous");
          });

          $("#fk_rightbar").click(function (e) {

            e.preventDefault();
            oTurn.turn("next");



          });

          

        }

      };

      module.init('book');
    }());






    $('link[rel=stylesheet][href~="/Content/startpagestyle.css"]').remove();
    window.onresize = (e) => {
     
      this.ngZone.run(() => {
      });
    };
  }

  private loadScript(scriptUrl: string) {

    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    })
  }



}


